import { baseResponseModel } from "src/app/shared/models/base";

export class signOutRequestModel {
  refresh: string;

  constructor() {
    this.refresh = '';
  }
}

export interface signOutResponseModel extends baseResponseModel {
  data: dataModel;
  error: errorModel;
  detail: string;
  code: string;
}

export interface dataModel {
  message: string[];
}

export interface errorModel {
  refresh: string[];
  message: string[];
}